(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfileInitController', ProfileInitController);

    ProfileInitController.$inject = ['$stateParams', '$scope', '$state', '$timeout', 'DataUtils', 'Principal', 'Auth', 'Position', 'Education', 'Collectivity', 'Company', 'Profile', 'Account'];

    function ProfileInitController($stateParams, $scope, $state, $timeout, DataUtils, Principal, Auth, Position, Education, Collectivity, Company, Profile, Account) {
        var vm = this;

        vm.authSuccess = authSuccess;
        vm.authenticationError = false;


        vm.key= $stateParams.key

        vm.profileInitForm;
        vm.mode = null;
        vm.profile = {};
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        //vm.educations = Education.query();
        vm.save = save;
        vm.setPicture = setPicture;
        vm.switchTo = switchTo;
        vm.conditions = false;

        vm.organizationsNoResults = false;
        vm.getOrganizations = getOrganizations;

        vm.addCurrentPosition = addCurrentPosition;
        vm.addPastPosition = addPastPosition;

        vm.profilesNoResults = false;
        vm.getProfiles = getProfiles;

        vm.readOnlyInitTitle = false;
        vm.readOnlyInitOrganisation = false;
        vm.init = init;

        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.initError = false;

        if (vm.key && vm.key !== "") {
            Auth.loginWithKey({
                key: vm.key
            },  vm.authSuccess).then(function () {
                vm.authenticationError = false;
                $rootScope.$broadcast('authenticationSuccess');
                init(account.data);
            }).catch(function () {
                vm.authenticationError = true;
            });
        } else {
            Account.getByKey({key:vm.key}, init, onError);
        }

        vm.switchTo('manual')


       function authSuccess(){
            Account.getByKey({key:vm.key}, init, onError);
       }

       function init(account){
            vm.authenticationError = false;
            vm.profile.user = account.data;
            vm.profile.email = vm.profile.user.email;
            vm.profile.lastName = vm.profile.user.lastName;
            vm.profile.firstName = vm.profile.user.firstName;

            angular.element('.form-group:eq(1)>input').focus();

            vm.currentPositions = [];
            vm.pastPositions = [];

            var initTitle = null;
            if (vm.profile.user.initTitle){
                initTitle = vm.profile.user.initTitle;


            } else if (Principal.hasAnyAuthority(['ROLE_COMMERCIAL'])){
                initTitle = 'Commercial';
            } else if (Principal.hasAnyAuthority(['ROLE_CONSULTANT'])){
                initTitle = 'Consultant';
                vm.readOnlyInitTitle = true;
            }

            var initOrganisation = null;
            if (vm.profile.user.initOrganisation){
                initOrganisation = vm.profile.user.initOrganisation;
            }

            var initSuperior = null;
            if (vm.profile.user.initSuperior){
                initSuperior = vm.profile.user.initSuperior;
            }

            //NOTE: Si je suis consultant, mon entreprise est renseignée automatiquement en independant et mon job en Consultant et je ne peux pas changer.
            // En revanche, je peux ajouter un autre job comme pour tous les utilisateurs à cette etape la.
            if (Principal.hasAnyAuthority(['ROLE_CONSULTANT'])) {
                if (initOrganisation){
                    vm.readOnlyInitOrganisation = true;
                }
                if (initTitle){
                    vm.readOnlyInitTitle = true;
                }
                if (initSuperior){
                    vm.readOnlyInitSuperior = true;
                }
            }
            vm.currentPositions.push({"readOnlyInitTitle": vm.readOnlyInitTitle, "readOnlyInitOrganisation": vm.readOnlyInitOrganisation, "readOnlyInitSuperior": vm.readOnlyInitSuperior, "active":true, "organisation":initOrganisation, "title":initTitle, "superior":initSuperior});
        };
        function onError(error) {
            console.log(error.data);
            vm.authenticationError = true;
        }

        function addCurrentPosition() {
            vm.currentPositions.push({"active":true, "readOnlyInitTitle": false, "readOnlyInitOrganisation": false, "readOnlyInitSuperior": false});
        }

        function addPastPosition() {
            vm.pastPositions.push({"active":false});
        }


        vm.setPicture = function ($file, profile) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        profile.picture = base64Data;
                        profile.pictureContentType = $file.type;
                    });
                });
            }
        };

        function getProfiles(q) {
            return Profile.search({ query: q }).$promise.then(function (profiles) {

                return profiles;
            });
        }

        function getOrganizations(q) {
            return Company.search({ query: q }).$promise.then(function (companies) {
                return Collectivity.search({ query: q }).$promise.then(function (collectivities) {
                    var organizations = companies.concat(collectivities);
                    // vm.organizationsNoResults = organizations.length === 0;
                    // vm.profileInitForm.organisation.$setValidity('exist',  organizations.length !== 0);
                    return organizations;
                });
            });
        }


        function switchTo(value) {
            if (value === 'linkedin' || value === 'manual') {
                vm.mode = value;
            } else {
                vm.mode = null;
            }
        }

        function save () {
            vm.isSaving = true;
            vm.profile.email = vm.profile.user.email;
            vm.profile.positions = vm.currentPositions.concat(vm.pastPositions);

            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
                vm.isSaving = false;
            } else {
                vm.doNotMatch = null;
                vm.profile.password = vm.password;
                Profile.init(vm.profile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:profileUpdate', result);
            vm.isSaving = false;
            vm.error = null;
            vm.success = 'OK';

            Auth.authorize(true, true).then(function () {
                $state.go('home', {}, {reload: true});
            });
        }

        function onSaveError () {
            vm.isSaving = false;
            vm.success = null;
            vm.error = 'ERROR';
        }


        function setPicture($file, profile) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        profile.picture = base64Data;
                        profile.pictureContentType = $file.type;
                    });
                });
            }
        }
    }
})();
